function getValueByPath(obj, path) {
  return path.split('.').reduce((acc, part) => {
    // Handle complex path parts that may contain array indices
    // eslint-disable-next-line no-useless-escape
    const segments = part.match(/([^\[\]]+)|\[(\d+)\]/g) || [];

    return segments.reduce((result, segment) => {
      if (!result) return null;

      // Check if segment is an array index
      if (segment.startsWith('[') && segment.endsWith(']')) {
        const index = parseInt(segment.slice(1, -1));
        return result[index];
      }

      // Handle regular object property
      return result[segment] !== undefined ? result[segment] : null;
    }, acc);
  }, obj);
}

export function validateForm(form, rules) {
  const validationResults = [];

  for (const field of rules) {
    const fieldErrors = [];
    const value = getValueByPath(form, field.name);
    if (field.rules.includes('required') && !value) {
      fieldErrors.push({ error: 'required', params: null });
    }

    if (
      field.rules.includes('email') &&
      value &&
      !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
    ) {
      fieldErrors.push({ error: 'email', params: null });
    }

    const minRule = field.rules.match(/min:(\d+)/);
    if (minRule && value && value.length < parseInt(minRule[1])) {
      fieldErrors.push({ error: 'min', params: { min: minRule[1] } });
    }

    const maxRule = field.rules.match(/max:(\d+)/);
    if (maxRule && value && value.length > parseInt(maxRule[1])) {
      fieldErrors.push({ error: 'max', params: { max: maxRule[1] } });
    }

    if (fieldErrors.length > 0) {
      validationResults.push({ field: field.name, errors: fieldErrors });
    }
  }

  return {
    valid: validationResults.length === 0,
    errors: validationResults,
  };
}
